import { render, staticRenderFns } from "./SalesBySegment.vue?vue&type=template&id=550e6088&"
import script from "./SalesBySegment.vue?vue&type=script&lang=js&"
export * from "./SalesBySegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports